import React from "react";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Button
} from "@chakra-ui/react";

const RecurrenceChangeModal = ({ isOpen, onClose, onConfirm, selectedTicket }) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Potvrda izmjene tip zadatka</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    {selectedTicket ? (
                        <>Želite li promijeniti ponavljanje zadatka "<strong>{selectedTicket.name}</strong>"?</>
                    ) : (
                        <>Učitavanje detalja zadatka...</>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button colorScheme="blue" onClick={onConfirm} isDisabled={!selectedTicket}>Promijeni</Button>
                    <Button variant="ghost" onClick={onClose}>Povratak</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default RecurrenceChangeModal;